import {GetUnitsUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetUnitsUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetUnitsUrl = (): GetUnitsUrl =>
	new RemoteGetUnitsUrl(
		makeBFFApiUrl(ExternalLinkPoint.units),
		makeAuthorizeHttpClientDecorator(),
	);
